/**
 * Dummy / editorial home content (Peerspace-style marketplace storytelling).
 * Swap for CMS/API later without changing section layout.
 */

export const HERO_ACTIVITY_CHIPS = [
  { label: 'Photo booth', q: 'photo booth' },
  { label: 'Wedding', q: 'wedding' },
  { label: 'Birthday party', q: 'birthday' },
  { label: 'Corporate event', q: 'corporate' },
  { label: 'DJ & music', q: 'dj' },
  { label: 'Photography', q: 'photography' },
];

export const MADE_ON_VENDALIST = [
  {
    id: 'made-1',
    title: 'Mirror booth, rooftop reception',
    meta: 'Downtown Toronto · Photo booth',
    image:
      'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80',
    href: '/browse-vendors',
  },
  {
    id: 'made-2',
    title: 'Golden-hour couple portraits',
    meta: 'Vancouver · Photography',
    image:
      'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1200&q=80',
    href: '/browse-vendors',
  },
  {
    id: 'made-3',
    title: 'Brand launch with live DJ',
    meta: 'Calgary · DJ & music',
    image:
      'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=1200&q=80',
    href: '/browse-vendors',
  },
  {
    id: 'made-4',
    title: 'Garden birthday, open-air booth',
    meta: 'Ottawa · Birthday',
    image:
      'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1200&q=80',
    href: '/browse-vendors',
  },
  {
    id: 'made-5',
    title: 'Ballroom wedding film crew',
    meta: 'Montreal · Videography',
    image:
      'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1200&q=80',
    href: '/browse-vendors',
  },
];

export const POSSIBILITIES_STEPS = [
  {
    number: '01',
    title: 'New and never-ending possibilities',
    description:
      'Find everything from classic photo booths to full event crews — studios, DJs, florists, and more for any celebration.',
  },
  {
    number: '02',
    title: 'Knowledgeable vendors',
    description:
      'Connect with experienced hosts to discuss packages, tech specs, and day-of logistics before you book.',
  },
  {
    number: '03',
    title: 'Easy budgeting',
    description:
      'Clear package pricing, secure checkout, and no mystery overtime fees. Know what you’re paying before you confirm.',
  },
];

export const WALLS_COULD_TALK = [
  {
    id: 'story-1',
    eyebrow: 'Hosts',
    title: 'Earn more as a VendaList vendor',
    body: 'List your booth, gear, or crew. Get discovered by planners already searching in your city.',
    image:
      'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1000&q=80',
    href: '/register',
  },
  {
    id: 'story-2',
    eyebrow: 'Product',
    title: 'The new VendaList: where celebrations begin',
    body: 'A calmer way to browse, compare, and book — built for parties that deserve better than a group chat spreadsheet.',
    image:
      'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=1000&q=80',
    href: '/how-it-works',
  },
  {
    id: 'story-3',
    eyebrow: 'Inspiration',
    title: 'Behind the scenes of a rooftop launch',
    body: 'How one team booked booth, DJ, and photography in a single afternoon — and still made it to cocktail hour.',
    image:
      'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1000&q=80',
    href: '/blog',
  },
  {
    id: 'story-4',
    eyebrow: 'Ideas',
    title: '10 photo booth themes guests actually love',
    body: 'From mirror glam to throwback film — dummy ideas to spark your next booking brief.',
    image:
      'https://images.unsplash.com/photo-1527529482830-5ea9904d9f0f?auto=format&fit=crop&w=1000&q=80',
    href: '/blog',
  },
];

export const DESTINATIONS = [
  {
    id: 'dest-1',
    city: 'Toronto',
    label: 'Photo booths & event vendors',
    region: 'Ontario, CA',
    image:
      'https://images.unsplash.com/photo-1517935703315-d146452819c0?auto=format&fit=crop&w=900&q=80',
    href: '/search?location=Toronto',
  },
  {
    id: 'dest-2',
    city: 'Vancouver',
    label: 'Wedding & party creatives',
    region: 'British Columbia, CA',
    image:
      'https://images.unsplash.com/photo-1559511260-2244b998e2da?auto=format&fit=crop&w=900&q=80',
    href: '/search?location=Vancouver',
  },
  {
    id: 'dest-3',
    city: 'Calgary',
    label: 'Corporate & celebration crews',
    region: 'Alberta, CA',
    image:
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=900&q=80',
    href: '/search?location=Calgary',
  },
  {
    id: 'dest-4',
    city: 'Montreal',
    label: 'Studios, DJs & nightlife',
    region: 'Quebec, CA',
    image:
      'https://images.unsplash.com/photo-1519178614-68673b201f36?auto=format&fit=crop&w=900&q=80',
    href: '/search?location=Montreal',
  },
];

export const EXTRAORDINARY_SLIDES = [
  {
    id: 'ex-1',
    kicker: '01 / 03',
    title: 'Where extraordinary begins',
    body: 'From first search to confirmed booking — vendors ready for the nights that matter.',
    image:
      'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1600&q=80',
  },
  {
    id: 'ex-2',
    kicker: '02 / 03',
    title: 'Hosts who know the craft',
    body: 'Talk amenities, timelines, and talent needs before call time — then book with confidence.',
    image:
      'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?auto=format&fit=crop&w=1600&q=80',
  },
  {
    id: 'ex-3',
    kicker: '03 / 03',
    title: 'Pay by the package, not the panic',
    body: 'Transparent pricing and secure checkout so the only surprise is how good the photos look.',
    image:
      'https://images.unsplash.com/photo-1478146896981-b80fe463b330?auto=format&fit=crop&w=1600&q=80',
  },
];
